import {
  ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET,
  ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET_SUCCESS,
  ADD_ACCOMMODATION_EXTRAS_TO_BASKET,
  ADD_ACCOMMODATION_EXTRAS_TO_BASKET_SUCCESS,
  ADD_ACCOMMODATION_TO_BASKET,
  ADD_ACCOMMODATION_TO_BASKET_SUCCESS,
  ADD_EXTRAS_TO_BASKET,
  ADD_NAME_CHANGE_TO_BASKET,
  ADD_TICKETS_TO_BASKET,
  ADD_TO_BASKET_FAILED,
  ADD_TRANSPORT_TO_BASKET,
  CHECK_BASKET,
  CHECK_BASKET_COMPLETE,
  CREATE_BASKET,
  CREATE_BASKET_SUCCESS,
  GET_BASKET,
  GET_BASKET_SUCCESS,
  PROCESSING_RESPONSE,
  REMOVE_ACCOMMODATION,
  REMOVE_EXTRA,
  REMOVE_ITEMS,
  RESET_BASKET,
  RESET_BASKET_SUCCESS,
} from './types';

import { DAS_UPDATE_TICKETS_FAILED_MAXIMUM_EXCEEDED } from '../../constants/errors';
import { createError } from '../errors';

export const createBasket = bookingRef => ({
  type: CREATE_BASKET,
  payload: { bookingRef },
});

export const createBasketSuccess = (bookingRef, basket) => ({
  type: CREATE_BASKET_SUCCESS,
  payload: { bookingRef, basket },
});

export const getBasket = bookingRef => ({
  type: GET_BASKET,
  payload: { bookingRef },
});

export const getBasketSuccess = (bookingRef, basket) => ({
  type: GET_BASKET_SUCCESS,
  payload: { bookingRef, basket },
});

export const addToBasketFailed = () => ({
  type: ADD_TO_BASKET_FAILED,
});

export const addTransportToBasket = (
  bookingRef,
  transport,
  hasBasket,
  basketPax = [],
) => ({
  type: ADD_TRANSPORT_TO_BASKET,
  payload: {
    bookingRef,
    transport,
    hasBasket,
    basketPax,
  },
});

export const addExtrasToBasket = (
  bookingRef,
  extras,
  hasBasket,
  basketPax,
  customerId,
) => ({
  type: ADD_EXTRAS_TO_BASKET,
  payload: { bookingRef, extras, hasBasket, basketPax, customerId },
});

export const addTicketsToBasket = (
  bookingRef,
  tickets,
  hasBasket,
  additionalPax,
) => ({
  type: ADD_TICKETS_TO_BASKET,
  payload: { bookingRef, tickets, hasBasket, additionalPax },
});

export const addAccommodationToBasket = (
  bookingRef,
  accommodations,
  hasBasket,
) => ({
  type: ADD_ACCOMMODATION_TO_BASKET,
  payload: { bookingRef, accommodations, hasBasket },
});

export const addAccommodationToBasketSuccess = accommodations => ({
  type: ADD_ACCOMMODATION_TO_BASKET_SUCCESS,
  payload: { accommodations },
});

export const addAccommodationExtrasToBasket = (bookingRef, extras) => ({
  type: ADD_ACCOMMODATION_EXTRAS_TO_BASKET,
  payload: { bookingRef, extras },
});

export const addAccommodationExtrasToBasketSuccess = () => ({
  type: ADD_ACCOMMODATION_EXTRAS_TO_BASKET_SUCCESS,
});

export const addAccommodationAndExtrasToBasket = (
  bookingRef,
  selectedRooms,
  selectedExtras,
  hasBasket,
  customerId,
  basketPax,
) => ({
  type: ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET,
  payload: {
    bookingRef,
    selectedRooms,
    selectedExtras,
    hasBasket,
    customerId,
    basketPax,
  },
});

export const addAccommodationAndExtrasToBasketSuccess = basket => ({
  type: ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET_SUCCESS,
  payload: { basket },
});

export const checkBasket = bookingRef => ({
  type: CHECK_BASKET,
  payload: { bookingRef },
});

export const checkBasketComplete = () => ({
  type: CHECK_BASKET_COMPLETE,
});

export const resetBasket = bookingRef => ({
  type: RESET_BASKET,
  payload: { bookingRef },
});

export const resetBasketSuccess = bookingRef => ({
  type: RESET_BASKET_SUCCESS,
  payload: { bookingRef },
});

export const removeAccommodation = (bookingRef, accoId, roomName, qty) => ({
  type: REMOVE_ACCOMMODATION,
  payload: { bookingRef, accoId, roomName, qty },
});

export const removeExtra = (bookingRef, extras, extrasToRemove) => ({
  type: REMOVE_EXTRA,
  payload: { bookingRef, extras, extrasToRemove },
});

export const removeItems = (bookingRef, items) => ({
  type: REMOVE_ITEMS,
  payload: { bookingRef, items },
});

export const showErrorMaximumTicketExceeded = () =>
  createError({
    code: DAS_UPDATE_TICKETS_FAILED_MAXIMUM_EXCEEDED,
    message: 'Your request exceeds the maximum number of allowed tickets',
  });

export const addNameChangeToBasket = (bookingRef, nameChange, hasBasket) => ({
  type: ADD_NAME_CHANGE_TO_BASKET,
  payload: {
    bookingRef,
    nameChange,
    hasBasket,
  },
});

export const awaitingServerResponse = processing => ({
  type: PROCESSING_RESPONSE,
  payload: { processing },
});
